import { Component } from '@angular/core';

@Component({
  selector: 'app-course-syllabus-button',
  template: '<ng-content></ng-content>'
})
export class CourseSyllabusButtonComponent {
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-syllabus-button/course-syllabus-button.component.ts